import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { PillRowComponent } from '../pill-row/pill-row.component';

@Component({
    selector: 'tran-pill-header-row',
    imports: [PillRowComponent],
    template: '<tran-pill-row [rowClasses]="rowClasses()"><ng-content /></tran-pill-row>',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PillHeaderRowComponent {
    public readonly rowClasses = input<string>('font-bold py-2 md:py-4');
}
